// File: src/main.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/context/AuthProvider";

import { SocketProvider } from "@/context/SocketProvider";
import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import App from "./App.jsx";
import "./index.css";

// ✅ Use the actual deployed base from index.html
const rawBase = document.querySelector("base")?.getAttribute("href") || "/";
const basename = rawBase.replace(/\/+$/, "") || "/";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <SocketProvider>
        <Toaster position="top-right" />
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} />
      </SocketProvider>
    </AuthProvider>
  </React.StrictMode>
);